import { token, styled, spacing } from '@landr/maestro';

export const UploadMessageWrapper = styled.div`
    position: fixed;
    bottom: ${spacing('jb')};
    right: ${spacing('jb')};
    width: ${token('containers.xs')};
`;
